import { Component, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

import { ROLES } from '@app/core/auth';

interface IRole {
  id: string;
  title: string;
}

export const defaultRoles: IRole[] = [
  {
    id: ROLES.User,
    title: 'Usuario',
  },
  {
    id: ROLES.Admin,
    title: 'Administrador',
  },
];

@Component({
  selector: 'app-role-select',
  templateUrl: './role-select.component.html',
})
export class RoleSelectComponent implements ControlValueAccessor {
  public selectedRole: IRole;
  public roles: IRole[];

  public isDisabled: boolean;

  private onChange: (val: any) => any;
  private onTouch: () => any;

  constructor(
    @Self()
    @Optional()
    public control: NgControl
  ) {
    this.control && (this.control.valueAccessor = this);
    this.roles = defaultRoles;
  }

  public get isInvalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get shouldShowError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;
    return this.isInvalid ? dirty || touched : false;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(input: any): void {
    this.selectedRole = input ? this.roles.find((r) => r.id === input) : null;
  }

  public selectedRoleChanged(): void {
    this.onChange(this.selectedRole.id);
    this.onTouch();
  }
}
